Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "addToCartButton2780601075",
  {"root":"addToCartButton2780601075--root"},
  "",
  8,
  "addToCartButton2780601075"
);

